import React from 'react';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import SectionContent from '../components/SectionContent';
import Img from '../../../../../components/Img/Img';
import { SectionTab } from '../../types';
import { EventDetailSectionItem } from '../../../../../types/query/event/detail';
import { EVENT_SECTION_TYPE_TEXT_V2, EVENT_SECTION_TYPE_V2 } from '../../../../../constants/service/app/eventConstants';
import SectionNavigationTabIcon from '../../../../../static/images/event/section_navigation_tab_icon.svg';
import { SectionNavigationTabStyle } from '../style';

interface UseContentListProps extends FormComponentProps {
  sectionList: EventDetailSectionItem[];
}
const useContentList = (props: UseContentListProps) => {
  const { form, sectionList } = props;
  const tabList: SectionTab[] = form.getFieldValue('sectionTabList') ?? [
    {
      id: 0,
      name: 'section-item-0',
      type: EVENT_SECTION_TYPE_V2.IMAGE,
      isSectionMobility: false,
    },
  ];

  const normalizedSectionList: {
    [key: string]: EventDetailSectionItem;
  } = sectionList.reduce((accumulator, currentValue) => ({ ...accumulator, [currentValue.id]: currentValue }), {});

  const contentList = tabList.map((item, index) => {
    const titleText = `${index + 1} - ${EVENT_SECTION_TYPE_TEXT_V2[item.type]}`;
    const title = item.isSectionMobility ? (
      <SectionNavigationTabStyle>
        <Img src={SectionNavigationTabIcon} clickAble={false} />
        {titleText}
      </SectionNavigationTabStyle>
    ) : (
      titleText
    );

    return {
      id: item.id,
      title,
      content: <SectionContent key={item.id} form={form} sectionItem={normalizedSectionList[item.id]} {...item} />,
      forceRender: true,
    };
  });

  return contentList;
};

export default useContentList;
